/**
 * pdfjs-dist 5.x 现代构建依赖部分较新的 Web API，旧内核缺失时会在 getDocument 等路径抛错。
 * 须在加载 react-pdf / pdfjs 之前导入本模块（侧效）。
 *
 * - Promise.withResolvers（ES2024）
 * - URL.parse（较新 Chromium 才有；getUrlProp 会调用）
 */
type WithResolversFn = <T>() => {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: unknown) => void;
};

type PromiseWithPolyfill = PromiseConstructor & {
  withResolvers?: WithResolversFn;
};

if (typeof Promise !== "undefined") {
  const P = Promise as PromiseWithPolyfill;
  if (typeof P.withResolvers !== "function") {
    (P as PromiseConstructor & { withResolvers: WithResolversFn }).withResolvers =
      function <T>() {
        let resolve!: (value: T | PromiseLike<T>) => void;
        let reject!: (reason?: unknown) => void;
        const promise = new Promise<T>((res, rej) => {
          resolve = res;
          reject = rej;
        });
        return { promise, resolve, reject };
      };
  }
}

type URLParseFn = (url: string | URL, base?: string | URL) => URL | null;

if (typeof URL !== "undefined") {
  const U = URL as typeof URL & { parse?: URLParseFn };
  if (typeof U.parse !== "function") {
    (U as typeof URL & { parse: URLParseFn }).parse = function (
      url: string | URL,
      base?: string | URL,
    ): URL | null {
      try {
        if (arguments.length < 2 || base === undefined) {
          return new URL(String(url));
        }
        return new URL(String(url), String(base));
      } catch {
        return null;
      }
    };
  }
}

export {};
